import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=3fd2a003&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=3fd2a003&prod&scoped=true&lang=css"
import style1 from "./comment.vue?vue&type=style&index=1&id=3fd2a003&prod&scoped=true&lang=css"
import style2 from "./comment.vue?vue&type=style&index=2&id=3fd2a003&prod&scoped=true&lang=css"
import style3 from "./comment.vue?vue&type=style&index=3&id=3fd2a003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2a003",
  null
  
)

export default component.exports